import React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const LargeExportModal = ({
  open,
  onClose,
  email,
  onEmailChange,
  onSend,
  exporting,
  exportSizeInfo,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 12,
        },
      }}
    >
      <DialogTitle style={{ paddingBottom: 8 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '1.25rem', fontWeight: 600 }}>Large File Export</span>
          <IconButton
            onClick={onClose}
            size="small"
            style={{ color: '#666' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ marginBottom: '16px', color: '#555', fontSize: '0.95rem' }}>
          <p style={{ margin: '0 0 8px 0' }}>This export contains a large number of records.</p>
          <p style={{ margin: '0 0 16px 0' }}>Please enter your email address to receive a download link.</p>
          
          {exportSizeInfo && (
            <div style={{ 
              marginBottom: '16px', 
              padding: '12px', 
              backgroundColor: '#f5f5f5', 
              borderRadius: '8px',
              fontSize: '0.9rem'
            }}>
              <p style={{ margin: '4px 0' }}>
                <strong>Records:</strong> {exportSizeInfo.rowCount.toLocaleString()}
              </p>
            </div>
          )}
        </div>
        
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexDirection: 'row' }} className="flex flex-col sm:flex-row">
          <TextField
            autoFocus
            type="email"
            placeholder="Enter Email Address"
            variant="outlined"
            value={email}
            onChange={onEmailChange}
            style={{ flex: 1 }}
          />
          <Button
            onClick={onSend}
            variant="contained"
            color="primary"
            disabled={exporting}
            style={{
              textTransform: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              minWidth: '100px',
              height: '56px',
            }}
          >
            {exporting ? "Sending..." : "SEND"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LargeExportModal;
